import { useState } from 'react';
import { LOCALES, LOCALE_META } from '../lib/locales';
import { setMyLanguages } from '../lib/api';

/** Reviewers choose the languages they can judge, and change their mind later.
 *  Self-service is safe: a language only decides what you may *suggest*, and
 *  nothing reaches the app without the owner approving it. */
export default function LanguagePicker({
  current, onSaved,
}: { current: string[]; onSaved: (langs: string[]) => void }) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState<string[]>(current);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const toggle = (l: string) =>
    setDraft((d) => (d.includes(l) ? d.filter((x) => x !== l) : [...d, l]));

  async function save() {
    if (!draft.length) return setError('Keep at least one language.');
    setBusy(true); setError(null);
    try { await setMyLanguages(draft); onSaved(draft); setOpen(false); }
    catch (e) { setError(e instanceof Error ? e.message : String(e)); }
    finally { setBusy(false); }
  }

  if (!open) {
    return (
      <button className="btn sm" onClick={() => { setDraft(current); setOpen(true); }}>
        Change languages
      </button>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {LOCALES.map((l) => (
        <button key={l} className="lp" aria-pressed={draft.includes(l)} onClick={() => toggle(l)}
          style={{ padding: '6px 9px' }}>
          <span style={{ flex: 1 }}>
            <span className="nm2" style={{ display: 'block', fontSize: 12 }}>{LOCALE_META[l].native}</span>
          </span>
        </button>
      ))}
      {error && <span className="hint" style={{ color: 'var(--crit)' }}>{error}</span>}
      <div style={{ display: 'flex', gap: 6 }}>
        <button className="btn sm pri" onClick={() => void save()} disabled={busy}>
          {busy ? 'Saving…' : 'Save'}
        </button>
        <button className="btn sm" onClick={() => setOpen(false)} disabled={busy}>Cancel</button>
      </div>
    </div>
  );
}
